import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RepresentativeController } from 'infraestructure/controllers/representativeController'
import { UpdateRoleRepresentativeCommandRequest } from 'domain/entities/representative'
import { Status } from 'domain/models/apiResponse'
import {
  representativeState,
  updateRoleRepresentativeError,
  updateRoleRepresentativeStart,
  updateRoleRepresentativeSuccess,
} from 'presentation/redux/slices/representativeSlice'
import useError from 'presentation/hooks/useError'

export const useUpdateRoleRepresentative = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(representativeState)
  const { getErrorMessage } = useError()

  const updateRoleRepresentative = useCallback(
    async (
      promotionId: string,
      representativeId: string,
      data: UpdateRoleRepresentativeCommandRequest,
    ) => {
      dispatch(updateRoleRepresentativeStart())
      try {
        const response = await RepresentativeController.updateRole(
          promotionId,
          representativeId,
          data,
        )
        if (response?.status === Status.success) {
          dispatch(updateRoleRepresentativeSuccess())
          return true
        }
      } catch (err) {
        dispatch(updateRoleRepresentativeError(getErrorMessage({ error: err })))
        return false
      }
    },
    [dispatch, getErrorMessage],
  )

  return { updateRoleRepresentative, isLoading, error }
}
